import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-toggles-page',
  templateUrl: './toggles-page.component.html',
  styleUrls: ['./toggles-page.component.scss']
})
export class TogglesPageComponent implements OnInit {

  constructor() { }

  public oneLoading = false;
  public one = false;

  public twoEmailLoading = false;
  public twoTextLoading = false;
  public two = false;

  public threeText = false;
  public threeEmail = false;

  public four1 = true;
  public four2 = true;
  public four3 = true;
  public four4 = true;

  ngOnInit() {
  }

  public swapOne() {
    this.oneLoading = true;

    setTimeout(() => {
      this.one = !this.one;
      this.oneLoading = false;
    }, 1000);
  } 

  public swapTwoText(){
    this.twoTextLoading = true;

    setTimeout(() => {
      this.two = !this.two;
      this.twoTextLoading = false;
    }, 1000);
  }

  
  public swapTwoEmail(){
    this.twoEmailLoading = true;

    setTimeout(() => {
      this.two = !this.two;
      this.twoEmailLoading = false;
    }, 1000);
  }

}
